import { LOCALE_LABELS } from "../../client/ts/locale/labels";

export class ClientError extends Error {
    constructor(message) {
        super(message);
    }
}

export const CheckoutConnectionError: ClientError = new ClientError(LOCALE_LABELS.ERRORS_CHECKOUT);
